import { useState, useEffect, useRef } from "react";
import CustomModal from "../../components/modal";
import Button from "../../components/button";
import { usePresence } from "./usePresence";
import { PRESENCE_STATUS_LABELS } from "./PresenceDot";

const PresenceConfirmationModal = () => {
    const { status, needsConfirmation, updateStatus } = usePresence();
    const [dismissed, setDismissed] = useState(false);
    const [confirming, setConfirming] = useState(false);
    const isMountedRef = useRef(true);

    useEffect(() => {
        return () => { isMountedRef.current = false; };
    }, []);

    const isOpen = needsConfirmation && !dismissed;
    const handleDecline = () => setDismissed(true);

    const handleConfirm = async () => {
        setConfirming(true);
        try {
            await updateStatus("Online");
        } finally {
            if (isMountedRef.current) {
                setConfirming(false);
            }
        }
    };

    return (
        <CustomModal
            isOpen={isOpen}
            title="Update Your Status"
            toggleModal={handleDecline}
            disableBackdropToggle={true}
            size="small"
        >
            <>
                <div className="font14Grey ms-4 mt-5 d-flex justify-content-start">
                    Your status is still {PRESENCE_STATUS_LABELS[status] ?? status}. Set to Online?
                </div>
                <div className="w-100 mt-5">
                    <div className="border-top mb-2" />
                    <div className="my-3 d-flex justify-content-center">
                        <Button
                            label="Not Now"
                            type="button"
                            onClick={handleDecline}
                            className="btn-light mx-2"
                            disabled={confirming}
                        />
                        <Button
                            label="Set to Online"
                            type="button"
                            onClick={handleConfirm}
                            className="btn-blue"
                            disabled={confirming}
                        />
                    </div>
                </div>
            </>
        </CustomModal>
    );
};

export default PresenceConfirmationModal;
